export const CUSTOMER_INVOICES_TABLE_DEFAULT_PAGE_SIZE = 10;
